import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from "@angular/common/http";
import { Inject, Injectable, OnInit, Optional, inject } from "@angular/core";
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { blobToText, processProblemResponse } from "./service-functions";
import { API_BASE_URL } from "./service-shared";
import { environment } from "environments/environment";
import { CommonBaseModel, FormServiceModelFactory } from "../model";

@Injectable({ providedIn: 'root' })
export class ServiceProxyBase implements OnInit {
    protected http: HttpClient = inject(HttpClient);
    protected baseUrl: string;
    protected dashboardUrl: string;
    protected baseUploadUrl: string;
    protected baseCsvUrl: string;

    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
        // @Inject(HttpClient) http: HttpClient,
        @Optional() @Inject(API_BASE_URL) baseUrl?: string
    ) {
        this.baseUrl = (baseUrl ?? '') + (environment.config?.formServiceEndpoint ?? '');
        this.dashboardUrl = (baseUrl ?? '') + (environment.config?.dashboardServiceEndpoint ?? environment.config?.formServiceEndpoint ?? '');
        this.baseUploadUrl = (baseUrl ?? '') + (environment.config?.fileUploadEndpoint ?? '');
        this.baseCsvUrl = (baseUrl ?? '') + (environment.config?.csvEndpoint !== undefined ? environment.config.csvEndpoint : '');
    }

    async ngOnInit() {
    }

    protected createPostOptions(data: any) {
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json, text/javascript, text/plain, */*; q=0.01"
            })
        };

        if (data) {
            options_['body'] = typeof data == 'string'
                ? data || '{}'
                : JSON.stringify(data);
            // options_['body'] = data;
        }

        return options_;
    };



    protected createHttpObserver<T extends CommonBaseModel>(type: { new(): T; }, method: string, url_: string, options_: any): Observable<T | null> {
        return this.http.request(method, url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processHttpResponse(type, response_);
                }),
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processHttpResponse(type, response_);
                        } catch (e) {
                            return _observableThrow(() => new Error(e));
                        }
                    }

                    return _observableThrow(() => new Error(response_));
                })
            );
    }

    protected processHttpResponse<T extends CommonBaseModel>(type: { new(): T; }, response: HttpResponseBase): Observable<T | null> {
        const status = response.status,
            responsePayload = response instanceof HttpResponse ? response.body : (response as any).error,
            _headers: any = {};

        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        var factory = new FormServiceModelFactory<T>();
        if (status === 200) {
            if (responsePayload instanceof Blob) {
                return blobToText(responsePayload)
                    .pipe(_observableMergeMap(_responseText => {
                        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                        let result200 = factory.fromJS(type, resultData200);
                        return _observableOf(result200);
                    }));
            } else if (typeof responsePayload == 'object') {
                return new Observable<T | null>((observer: any) => {
                    let res = null;
                    try {
                        var obj = responsePayload.d ?? responsePayload;
                        if (typeof obj == 'object') {
                            res = obj;
                        } else {
                            res = JSON.parse(obj);
                        }
                    } catch (e) { }

                    if (Object.keys(res).length == 1 && Object.hasOwn(res, 'response')) {
                        res = res['response'];
                    }

                    observer.next(res ? factory.fromJS(type, res) : res);
                    observer.complete();
                });
            }
        } else if (status === 204) {
            return new Observable((subscriber) => {
                subscriber.next(null);
                subscriber.complete();
            });
        }

        return processProblemResponse(status, responsePayload, _headers, this.jsonParseReviver)
            ?? _observableOf<object | null>(null);
    }
}
